"use client";

import Image from "next/image";
import { useEffect, useRef } from "react";

export default function ProfileHeroMedia() {
  const containerRef = useRef(null);
  const mediaRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const media = mediaRef.current;
    if (!container || !media) return undefined;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }

    let animationFrame;

    const updatePosition = () => {
      animationFrame = undefined;
      const travelled = Math.min(
        Math.max(window.scrollY || document.documentElement.scrollTop, 0),
        container.offsetHeight,
      );
      media.style.transform = `translate3d(0, ${travelled * 0.14}px, 0)`;
    };

    const requestUpdate = () => {
      if (animationFrame) return;
      animationFrame = window.requestAnimationFrame(updatePosition);
    };

    updatePosition();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);

    return () => {
      window.removeEventListener("scroll", requestUpdate);
      window.removeEventListener("resize", requestUpdate);
      if (animationFrame) window.cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="mushtaq-hero-media absolute inset-x-0 top-0 h-[1080px] overflow-hidden"
    >
      <div
        ref={mediaRef}
        className="absolute -inset-y-[8%] inset-x-0 origin-center will-change-transform"
      >
        <div className="mushtaq-hero-focus absolute -bottom-8 left-1/2 top-10 origin-top -translate-x-1/2 scale-[1.08]">
          <Image
            src="/mushtaq_khan_alpha_appraisals.webp"
            alt="Mushtaq Khan, P.App., CRA"
            fill
            priority
            sizes="(min-width: 1536px) 900px, (min-width: 640px) 760px, 100vw"
            className="object-contain object-top"
          />
          <div className="mushtaq-portrait-fade-left absolute inset-y-0 left-0 w-[24%]" />
          <div className="mushtaq-portrait-fade-right absolute inset-y-0 right-0 w-[24%]" />
        </div>
      </div>
      <div className="mushtaq-hero-fade-bottom absolute inset-0" />
      <div className="mushtaq-hero-fade-sides absolute inset-0" />
      <div className="mushtaq-hero-fade-mobile absolute inset-x-0 bottom-0 top-[250px] sm:hidden" />
      <div className="mushtaq-hero-side-left mushtaq-portrait-fade-left absolute inset-y-0 left-0 w-[36%]" />
      <div className="mushtaq-hero-side-right mushtaq-portrait-fade-right absolute inset-y-0 right-0 w-[36%]" />
    </div>
  );
}
